import { dayjs } from 'utils/dayjs';

/**
 * RFC 3339 / Atom: "2026-09-08T21:19:00-05:00". `Z` renders the offset with a colon.
 */
const ATOM = 'YYYY-MM-DDTHH:mm:ssZ';

export const getYearMonthDayDate = (date: Date) => {
  const isDate = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
  return new Date(isDate.replace(/-/g, '/'));
};

export const formatDeadline = (date: Date | null) => (
  // moment was given 'DD/MM-YYYY' here too, which it ignores for a Date.
  date && dayjs(date).format('(DD/MM-YYYY)')
);

export interface AtomOptions {
  zone?: string;
}

/**
 * Formats an instant as an Atom/RFC 3339 timestamp with a numeric offset.
 *
 * @param date  Date to format, or a string that can be parsed by `dayjs`.
 *              Omit for the current time.
 * @param zone  IANA zone name, e.g. "Europe/Oslo". Defaults to the runtime's zone.
 *
 * @throws RangeError if `date` can't be parsed or `zone` isn't a known IANA name.
 */
export function toAtom(date?: dayjs.ConfigType, { zone }: AtomOptions = {}): string {
  const d = zone ? dayjs(date).tz(zone) : dayjs(date);

  if (!d.isValid()) {
    throw new RangeError(`toAtom: cannot parse ${JSON.stringify(date)}`);
  }

  return d.format(ATOM);
}
